// extracted by mini-css-extract-plugin
module.exports = {"container":"EVsCardItemComponent_container__YYcGA","footer":"EVsCardItemComponent_footer__g3I_n","selected":"EVsCardItemComponent_selected__g7mhe"};